import { Injectable, inject } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import { Account } from '@pinnakl/shared/types';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private wsp = inject(WebServiceProvider);
  private readonly apiUrls = inject(API_URLS);

  private _accounts: Account[];

  getAccounts(): Promise<Account[]> {
    if (this._accounts) {
      return Promise.resolve(this._accounts);
    }
    return this.wsp
      .get<Account[]>({
        endpoint: this.apiUrls.accountsV3,
      })
      .then(accounts => {
        this._accounts = accounts;
        return this._accounts;
      });
  }
}
